import { render } from "./TeItiKahurangiFormComponent.vue?vue&type=template&id=cd4ac818&scoped=true"
import script from "./TeItiKahurangiFormComponent.vue?vue&type=script&lang=js"
export * from "./TeItiKahurangiFormComponent.vue?vue&type=script&lang=js"

import "./TeItiKahurangiFormComponent.vue?vue&type=style&index=0&id=cd4ac818&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd4ac818"]])

export default __exports__